import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import Section from '../ui/Section';
import Button from '../ui/Button';

const CallToAction: React.FC = () => {
  return (
    <Section className="bg-gradient-to-b from-background via-neutral-900/50 to-background">
      <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl p-8 md:p-12 border border-primary/20 text-center backdrop-blur-sm">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Transform Your AI Product Strategy?</h2>
        <p className="text-xl text-neutral-300 mb-8 max-w-2xl mx-auto">
          Book a free 30-minute consultation to discuss your AI product challenges and opportunities.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a href="https://calendly.com/prodaiconsulting/30min" target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="group">
              <Calendar size={18} className="mr-2" />
              Book a Strategy Call
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </a>
          <a href="https://calendly.com/prodaiconsulting/30min" target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" size="lg">
              Contact Us
            </Button>
          </a>
        </div>
      </div>
    </Section>
  );
};

export default CallToAction;